"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoardActions = void 0;
class BoardActions {
    static isResetBoard(a) {
        return a.tag === 'resetboard';
    }
    static isDealCards(a) {
        return a.tag === 'dealcards';
    }
    static isDealFlop(a) {
        return a.tag === 'dealflop';
    }
    static isDealTurn(a) {
        return a.tag === 'dealturn';
    }
    static isDealRiver(a) {
        return a.tag === 'dealriver';
    }
    static isEvalShowdown(a) {
        return a.tag === 'evalshowdown';
    }
}
exports.BoardActions = BoardActions;
BoardActions.ResetBoard = {
    tag: 'resetboard',
};
BoardActions.DealCards = {
    tag: 'dealcards',
};
BoardActions.DealFlop = {
    tag: 'dealflop',
};
BoardActions.DealTurn = {
    tag: 'dealturn',
};
BoardActions.DealRiver = {
    tag: 'dealriver',
};
BoardActions.EvalShowdown = {
    tag: 'evalshowdown',
};
//# sourceMappingURL=BoardStateAction.js.map